import { apiServer } from '../settings'
import {getToken} from './token'

const getGroupScoreLevelCounters = (game, shortId, done) => {
	if (!game) return done('missing game')
	if (!shortId) return done('missing shortId')

	const headers = new Headers({'Authorization': 'Bearer ' + getToken()})

	const options = { method: 'GET', headers, mode: 'cors', cache: 'default' }

	const url = `${apiServer}/group-score-level-counters?game=${game}&shortId=${shortId}`

	fetch(url, options)
		.then(function(response) {
			return response.json()
		})
		.then(function(response) {
			if (response.success === false) return done(response.err)
			if (response.success === true) return done(null, response.data)
			if (!response.success) return done('response without success true|false')
		})
}


export default getGroupScoreLevelCounters
